var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "javascript_2_",
    d: "M31,31.36H1v-0.72h30V31.36z M31,24.36H1c-0.199,0-0.36-0.161-0.36-0.36V1c0-0.199,0.161-0.36,0.36-0.36 h30c0.199,0,0.36,0.161,0.36,0.36v23C31.36,24.199,31.199,24.36,31,24.36z M1.36,23.64h29.28V1.36H1.36V23.64z M9.051,15.354v-0.182 c0-0.476,0.266-0.812,0.854-0.812s0.854,0.336,0.854,0.812v0.182c0,0.477-0.266,0.812-0.854,0.812 C9.317,16.166,9.051,15.83,9.051,15.354z M12.998,8.77h1.121v8.349c0,0.994-0.49,1.68-1.569,1.68h-0.728v-0.98h1.176V8.77z  M12.872,6.445V6.263c0-0.378,0.21-0.63,0.687-0.63s0.687,0.252,0.687,0.63v0.182c0,0.378-0.21,0.63-0.687,0.63 S12.872,6.823,12.872,6.445z M15.812,14.751l0.798-0.645c0.561,0.701,1.232,1.106,2.144,1.106c0.952,0,1.513-0.434,1.513-1.176 c0-0.561-0.309-0.995-1.261-1.135l-0.574-0.084c-1.331-0.196-2.326-0.743-2.326-2.087c0-1.429,1.107-2.129,2.578-2.129 c1.163,0,1.934,0.434,2.521,1.163l-0.742,0.672c-0.322-0.448-0.938-0.882-1.863-0.882s-1.415,0.434-1.415,1.121 c0,0.7,0.49,0.98,1.387,1.121l0.561,0.084c1.597,0.238,2.213,0.938,2.213,2.031c0,1.4-1.022,2.255-2.675,2.255 C17.339,16.166,16.456,15.606,15.812,14.751z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.c833e0ca2f62be1202426e5a384554d3.svg";
export { ForwardRef as ReactComponent };